export default __webpack_public_path__ + "static/media/autorep3.aac4fd4b.jpg";